import { createApiClient, type Session, type SessionStorage } from '@pixerito/api-client';

export { ApiError } from '@pixerito/api-client';

const STORAGE_KEY = 'pixerito.session';

/** Sessão no localStorage do navegador (o app mobile vai usar SecureStore com a mesma interface). */
const browserStorage: SessionStorage = {
  load() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? (JSON.parse(raw) as Session) : null;
    } catch {
      return null;
    }
  },
  save(session) {
    try {
      if (session) localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
      else localStorage.removeItem(STORAGE_KEY);
    } catch {
      /* sem storage (aba anônima bloqueada): a sessão dura só esta aba */
    }
  },
};

let onSessionExpired: () => void = () => {};

export function setSessionExpiredHandler(handler: () => void) {
  onSessionExpired = handler;
}

export const api = createApiClient({
  baseUrl: import.meta.env.VITE_API_URL ?? '',
  storage: browserStorage,
  onSessionExpired: () => onSessionExpired(),
});

export const hasSession = () => api.hasSession();
